import React from 'react';
import { TabNav } from './tabNav';
import { Button, Col, Row } from 'components';
import { ArrowLeftIcon } from 'components/common/icons';
import { Details } from 'pages/admin/deals/deal/details';
import { OriginalEmailAndRejection } from './details/OriginalEmailAndRejection';
import styles from './styles.module.scss';

export const Deal: React.FC = () => {
  return (
    <Row className={styles.deal}>
      <Col>
        <Button title={'Click to go back'} onClick={() => history.back()} type={'link'} icon={<ArrowLeftIcon />} />
      </Col>
      <Col className={styles.main_section}>
        <Row wrap={false}>
          <Col flex={'296px'}>
            <Row className={styles.left_banner}>
              <Col className={styles.details}>
                <Details />
              </Col>
              <OriginalEmailAndRejection />
            </Row>
          </Col>
          <Col flex={'1'} className={styles.right_section}>
            <TabNav />
          </Col>
        </Row>
      </Col>
    </Row>
  );
};

export default Deal;
